import React from "react";

export default function ShowPassword({onClick, showPwd}){
    return (
        <div className="flex items-center pl-0 pt-4 text-sm md:font-sans text-xs text-gray-800">
            <input 
                id="checked-checkbox" 
                type="checkbox" 
                value="" 
                onClick={onClick}
                className="w-4 h-4 text-pblue-400 bg-gray-100 rounded border-gray-300 focus:ring-pblue-400"
            />
            <span className="ml-1 inline">{showPwd? 'Hide password' : 'Show password'}</span>
        </div>
    )
}
